module.exports = __webpack_public_path__ + "img/h5_anljxz@3x.16768055.png";